module.exports = __webpack_public_path__ + "img/Pattern02.009fb203.png";